<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block" style="display:flex">
        <div class="block">
          <span class="demonstration" style="margin-right:10px">所属地区</span>
          <el-select placeholder="选择地区" v-model="addressItem" filterable clearable>
            <el-option
              v-for="item in addressSelectData"
              :key="item.id"
              :label="item.full_area_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>

        <div class="block" style="margin-left:20px;display:flex">
          <span class="countryName">国家名称</span>
          <!-- <el-cascader placeholder="请输入国家名称"></el-cascader> -->
          <el-input placeholder="模糊查询" v-model="countryName" clearable></el-input>
        </div>

        <div style="margin-left:20px">
          <el-row>
            <el-button type="success" @click="queryData()">查询</el-button>
            <el-button type="primary">导出</el-button>
          </el-row>
        </div>
      </div>
      <el-button type="success" style="margin:10px 0" @click="addCountryData()">新增条目</el-button>
      <el-table
        :data="tableData"
        style="width: 100%"
        :default-sort="{prop: 'date', order: 'descending'}"
      >
        <el-table-column prop="area_name" label="国家名称"></el-table-column>
        <el-table-column prop="add_time" label="创建时间" :formatter="addTime" sortable></el-table-column>
        <el-table-column prop="update_time" label="最后修改时间" :formatter="updateTime" sortable></el-table-column>
        <el-table-column prop="status" label="启用/禁用">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              @change="changeStatus(scope.row)"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="guide_status" label="启/禁用国别指南">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.guide_status"
              @change="changeGuideStatus(scope.row)"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="last_admin_username" label="操作人">
          <template slot-scope="scope">
            <span>{{scope.row.last_admin_username || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-row>
              <el-button type="text" size="small" @click="editCountryData(scope.row)">
                <i class="el-icon-edit"></i>编辑
              </el-button>
              <el-button type="text" size="small" @click="editGuideData(scope.row)">
                <i class="el-icon-edit"></i>编辑国别指南
              </el-button>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalList"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import api from "../api";
import { timestampToTime } from "@/mixins/tools.js";

export default {
  mixins: [timestampToTime],
  name: "CountryBase",
  data() {
    return {
      addressSelectData: null,
      addressItem: null,
      countryName: "",
      tableData: [],
      currentPage: 1,
      totalList: null
    };
  },
  created() {
    this.getData();
    this.initCommonData();
  },
  methods: {
    // 获取数据
    getData(data) {
      api.countryInfoList(data).then(res => {
        // this.$message("请求成功!");
        this.tableData = res.list;
        this.totalList = res.recordcount;
        this.pageSize = res.pagecount;
      });
      // .catch(err => {
      //   console.log(err);
      // });
    },

    // 查询参数
    queryData() {
      let data = {
        page: this.currentPage,
        area_id: this.addressItem,
        area_name: this.countryName
      };
      if (data.area_id) {
        this.getData(data);
      } else {
        this.getData();
      }
    },

    // 启动/禁用切换
    changeStatus(row) {
      let data = {
        id: row.id,
        status: row.status
      };
      api
        .startupDisable(data)
        .then(res => {
          this.$message({
            message: "切换成功",
            type: "success"
          });
        })
        // .catch(err => {
        //   this.$message(err);
        // });
    },

    changeGuideStatus(row) {
      let data = {
        id: row.id,
        guide_status: row.guide_status
      };
      api
        .adminGuideEdit(data)
        .then(res => {
          this.$message({
            message: "国别指南切换成功",
            type: "success"
          });
        })
        // .catch(err => {
        //   this.$message(err);
        // });
    },

    // 新增数据
    addCountryData() {
      this.$router.push({
        name: "addCountryData"
      });
    },

    // 修改数据
    editCountryData(row) {
      let routeData = this.$router.resolve({
        name: "addCountryData",
        query: {
          countryId: row.id,
          countryName: row.area_name,
          countryCapital: row.capital_name
        }
      });
      window.open(routeData.href, '_blank');
      
    },

     // 修改数据1.5新增
    editGuideData(row) {
      let routeData = this.$router.resolve({
        name: "editGuideData",
        query: {
          countryId: row.id,
        }
      });
      window.open(routeData.href, '_blank');
    },

    async initCommonData() {
      // 获取城市列表
      this.$commFunc.getAreaList().then(resData => {
        // debugger
        this.areaDataLoaded = true;
        this.addressSelectData = resData;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  text-align: right;
  padding: 0 20px;
}
.countryName {
  margin-right: 10px;
  width: 100px;
  justify-content: center;
  align-items: center;
  display: flex;
}
</style>